const API_URL = {
  AUTH: {
    INVITATION_PROFILE: "/invitation/profile",
    INVITATION_VALID: "/invitation/verify",
    LOGIN: "/login",
    LOGIN_ACCESS: "/login/accesstoken",
    LOGIN_USER: "/login",
    MAIL_VERIFICATION: "/register/verify-email/",
    REFRESH: "/login/refresh",
    RESEND_MAIL_VERIFICATION: "/register/resend-mail-verification/",
  },
  BOOKING: {
    ADD_EXTERNAL_GUEST: "/add-external-participant",
    ADD_FAVOURITE_CLUB: "/user/favourite/clubs",
    ADD_GUEST: "/add-participant",
    AMENITIES_NEXT_AVAILABILITY: "/amenities/next-availability/",
    BOOKING_CALENDAR: "/calendar/",
    BOOKING_EDIT: "/booking/edit/",
    BOOKING_SAVE: "/booking/save",
    BOOKING_SHARE: "/booking/detail",
    BOOKING_SLOT: "/resources/",
    CALCULATE_PRICE: "/calculate-price",
    CALENDAR_PARTICIPANT: "/booking/",
    CANCEL: "/booking/cancelBooking/",
    CHECK_CANCEL_FEASIBILITY: "/booking/checkBookingCancellable/",
    CHECK_GUEST_LIST: "/check-participants",
    CLEAR_BOOKING: "/booking/clearBooking",
    GET_AMENITIES: "/amenities",
    GET_GUEST_LIST: "/users/",
    GET_QUOTE_INFO: "/resources/quota/",
    PAYMENT_STATUS: "/booking/paymentStatus/",
    REMOVE_USER_FAVOURITES: "/user/favourites/remove",
    TOKENIZATION_STATUS: "/booking/tokenizationStatus/",
    UPCOMING_BOOKINGS: "/booking/upcoming",
    USER_FAVOURITES: "/user/favourites",
    USER_SYNC: "/user/sync/",
  },
  CONTACT_PERSON: {
    GET_CONTACT_PERSON: "/contact-info/",
  },
  DASHBOARD: {
    META_DATA: "/organizations/meta-data",
    ORGANIZATION_FINDER: "/organization",
  },
  DELETEACCOUNT: {
    ACCOUNT_DELETE: "/user/deleteAccount",
    CHECK_ACCOUNT_DELETE: "/user/checkAccountDeletion",
    CHECKPASSORD_ON_ACCOUNT_DELETE: "/user/checkPasswordOnAccountDeletion",
  },
  KIOSK: {
    ADD_EXTERNAL_GUEST: "/kiosk/add-external-participant",
    ADD_GUEST: "/kiosk/add-participant",
    AMENITIES_NEXT_AVAILABILITY: "/kiosk/amenities/next-availability/",
    BOOKING_CALENDAR: "/kiosk/calendar/",
    BOOKING_CALENDAR_PUBLIC: "/kiosk/calendar/public/",
    BOOKING_SAVE: "/kiosk/booking/save",
    BOOKING_SLOT: "/kiosk/resources/",
    BOOKING_SLOT_PUBLIC: "/kiosk/resources/public/",
    CALCULATE_PRICE: "/kiosk/calculate-price",
    CALENDAR_PARTICIPANT: "/kiosk/booking/",
    CANCEL_BOOKING: "/kiosk/booking/cancelBooking/",
    CHECK_CANCEL_FEASIBILITY: "/kiosk/booking/checkBookingCancellable/",
    CHECK_CONNECTIVITY: "/kiosk/check",
    CHECK_GUEST_LIST: "/kiosk/check-participants",
    CHECK_USER_PIN: "/kiosk/login-check",
    CONFIGURE: "/kiosk/configure",
    GET_AMENITIES: "/kiosk/amenities",
    GET_QUOTE_INFO: "/kiosk/resources/quota/",
    GET_SELECTED_LANGUAGE: "/kiosk/language",
    LANDING_PAGE: "/kiosk/landingpage",
    LOGIN: "/kiosk/login-pin",
    ORGANISATION_INFO: "/kiosk/organization",
    REFRESH: "/kiosk/login/refresh",
    REMOVE_USER_FAVOURITES: "/kiosk/user/favourites/remove",
    USER_BOOKING_DETAILS: "/kiosk/booking/listing/",
    USER_FAVOURITES: "/kiosk/user/favourites",
    USER_INFO: "/kiosk/users/",
    USER_PROFILE: "/kiosk/user/profile",
    USER_UPDATE_PAYMENT_STATUS: "/kiosk/booking/update-payment-status/",
  },
  NOTIFICATION: {
    DISABLE: "/notification/subscription/disable",
    ENABLE: "/notification/subscription/enable",
    SUBSCRIBE: "/notification/subscribe",
    UNSUBSCRIBE: "/notification/unsubscribe",
  },
  ORGANISATION: {
    GET_LOCATION: "/organization/",
  },
  PASSWORD: {
    INVITED_SET_PASSWORD: "/invitation/reset",
    RESET_PASSWORD: "/resetpassword",
    RESET_PASSWORD_TOKEN: "/reset/verify",
    SET_PASSWORD: "/reset",
  },
  TOKENISATION: {
    PAYMENT_METHODS: "/tokenization/paymentMethods",
  },
  UNIT: {
    DETAILS: "/location/",
  },
  USER: {
    GET_SELECTED_LANGUAGE: "/language",
    KIOSK_HOUSEHOLD_PROFILE_PIN: "/pin-settings/set-profile-pin",
    KIOSK_INDIVIDUAL_PIN: "/pin-settings/set-individual-pin",
    KIOSK_PROFILE_PIN: "/pin-settings/set-my-pin",
    KIOSK_SETUP_DATA: "/pin-settings/my-household-sync",
    KIOSK_SHARE_MY_PIN: "/pin-settings/share-my-pin",
    MEMBER_CLUBS: "/user/memberclubs",
    MEMBER_INFO: "/user/memberinfo",
    MEMBERSHIPS: "/user/memberships",
    REGISTER: "/register",
    REGISTER_OPTIONS: "/register-options",
    REGISTER_VALIDATE: "/register-validate",
    REMOVE_TEMP_HOUSEHOLD_MEMBER: "/pin-settings/remove/temp-household",
    SAVED_CARDS: "/tokenization/payments/saved-cards",
    UPDATE_USER_LANGUAGE: "/language",
    USER_BOOKING_DETAILS: "/booking/listing/",
    USER_BOOKINGS: "/booking/listing",
    USER_PROFILE: "/user/profile",
    USER_UPDATE_PAYMENT_STATUS: "/booking/update-payment-status/",
  },
};

export default API_URL;
